import { apiCall } from "../base";
import { HttpMethod } from "@/types/https";
import { ENDPOINT } from "../endpoint";
import {
  AiPayloadRecommendation,
  AiRecommendationResponse,
  ApplyAisuggestionPayload,
} from "../types/ai.type";

export const AiRecommendation = () => {
  return {
    name: `AiRecommendation`,
    handle: (): Promise<AiRecommendationResponse> =>
      apiCall<AiRecommendationResponse>({
        url: ENDPOINT.AI_SUGGESTION,
        method: HttpMethod.GET,
      }),
  };
};

export const DeleteSuggestion = () => {
  return {
    name: `DeleteSuggestionBychatUuid`,
    handle: (chatUuid: string): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.AI_SUGGESTION}/chat/${chatUuid}`,
        method: HttpMethod.DELETE,
      }),
  };
};

export const ChatSuggestionBy = (
  chatUuid: string,
  params: { showJsonTypeMessageContent: boolean },
) => {
  return {
    name: `ChatSuggestionByChatUuid`,
    handle: (): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.AI_SUGGESTION}/chat/${chatUuid}`,
        method: HttpMethod.GET,
        params,
      }),
  };
};

export const SaveAiRecommendation = () => {
  return {
    name: `SaveAiRecommendation`,
    handle: (payload: AiPayloadRecommendation): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.JOB_ORDERS}/bulk`,
        method: HttpMethod.PUT,
        body: payload,
      }),
  };
};

export const AskSuggestion = () => {
  return {
    name: "AskSuggestion",
    handle: (body: any): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.AI_SUGGESTION}/ask`,
        method: HttpMethod.POST,
        body,
      }),
  };
};

export const AskSuggestionContent = () => {
  return {
    name: "AskSuggestionContent",
    handle: (body: any) =>
      apiCall<any>({
        url: `${ENDPOINT.AI_SUGGESTION}/chat/content`,
        method: HttpMethod.POST,
        body,
      }),
  };
};

export const ViewJobSuggestionBy = (messageUuid: string) => ({
  name: "ViewJobSuggestionBy",
  handle: () =>
    apiCall<any>({
      url: `${ENDPOINT.AI_SUGGESTION}/json-message/${messageUuid}`,
      method: HttpMethod.GET,
    }),
});

export const ApplyAiSuggestion = () => {
  return {
    name: "ApplyAiSuggestion",
    handle: (payload: ApplyAisuggestionPayload[]): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.AI_SUGGESTION}/apply`,
        method: HttpMethod.PUT,
        body: payload,
      }),
  };
};
